module.exports = __webpack_public_path__ + "static/media/settings2.4a34c7ab.svg";